import React from 'react'

import Jeopardy from './components/Jeopardy'
import Quiz from './components/Quiz'
import Screenshare from './components/Screenshare'
import StaticTabs from './components/StaticTabs'
import Whiteboard from './components/Whiteboard'
import { Container } from './styles'

const LeftControls = () => {
    return (
        <Container>
            <StaticTabs />
            <Screenshare />
            <Whiteboard />
            <Quiz />
            <Jeopardy />
        </Container>
    )
}

LeftControls.propTypes = {}

export default LeftControls
